import { createRouter, createWebHistory } from "vue-router";
import store from '@/store.js';
import { timeNode } from "../utils";
import lotteryRouter from "@/views_lottery/helper/router";
import onlineInviteRoutes from '@/onlineInvite/helper/router' 
// const hotEvent = window.HotEvent;
const easyearn = window.easyearn;

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // activityDetail 已下线
    // start
    {
      path: '/activityDetail',
      name: 'ActivityDetail',
      component: () => import('@/views/main.vue'),
      redirect: timeNode() === 1 ? '/reservePage' : '/activityDetail',
      children: [
        {
          path: '/activityDetail',
          name: 'ActivityDetail',
          component: () => import('@/views/activityDeatil.vue'),
          meta: { showHeader: false, title: ''},
        },
        {
          path: '/sharePage',
          name: 'SharePage',
          component: () => import('@/views/sharePage.vue'),
          meta: { showHeader: false, title: '国庆寻宝'},
        },
        {
          path: '/reservePage',
          name: 'ReservePage',
          component: () => import('@/views/reservePage.vue'),
          meta: { showHeader: false, title: ''},
        },
        {
          path: '/rulesPage',
          name: 'RulesPage',
          component: () => import('@/views/rulesPage.vue'),
          meta: { showHeader: true, title: '活动规则'},
        },
        {
          path: '/detailPage',
          name: 'DetailPage',
          component: () => import('@/views/detailPage.vue'),
          meta: { showHeader: true, title: '红包记录'},
        },
        {
          path: '/honor',
          name: 'Honor',
          component: () => import('@/views/honor.vue'),
          meta: { showHeader: false, title: '大千光荣榜'},
        },
        {
          path: '/exam',
          name: 'Exam',
          component: () => import('@/views/exam.vue'),
          meta: { showHeader: false, title: '考试平台'},
        },
      ],
    }, 
    // end
    {
      path: '/integral',
      name: 'Integral',
      component: () => import('@/views/main.vue'),
      redirect: '/integral/index',
      children: [
        {
          path: '/integral/index',
          name: 'integralIndex',
          component: () => import('@/views_integral/index.vue'),
          meta: { showHeader: false, title: '积分中心' },
        },
        {
          path: '/integral/rights',
          name: 'integralRights',
          component: () => import('@/views_integral/rights.vue'),
          meta: { showHeader: false, title: '权益详情' },
        },
        {
          path: '/integral/detail',
          name: 'integralDetail',
          component: () => import('@/views_integral/detail.vue'),
          meta: { showHeader: false, title: '等级明细' },
        },
        {
          path: '/integral/rules',
          name: 'integralRules',
          component: () => import('@/views_integral/rules.vue'),
          meta: { showHeader: true, title: '企鹅汇图等级体系规则' },
        }
      ],
    },
    {
      path: '/',
      name: 'Main',
      component: () => import('@/views_v3.15.0/main.vue'),
      redirect: '/examination',
      children: [
        {
          path: '/examination',
          name: 'Examination',
          component: () => import('@/views_v3.15.0/examination.vue'),
        },
        {
          path: '/examreslut',
          name: 'Examreslut',
          component: () => import('@/views_v3.15.0/examreslut.vue'),
        },
        {
          path: '/examHelpPage',
          name: 'ExamHelpPage',
          component: () => import('@/views_v3.15.0/examHelpPage.vue'),
        }
      ],
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('@/view_message_appear/main.vue'),
      redirect: '/message_appear_type',
      children: [
        {
          path: '/message_appear_type',
          name: 'messageAppearType',
          component: () => import('@/view_message_appear/messageAppearType.vue'),
        },
        // 小程序
        {
          path: '/message_appear_detail',
          name: 'messageAppearDetail',
          component: () => import('@/view_message_appear/messageAppearDetail.vue'),
        },
        // 客户端h5
        {
          path: '/message_appear_detail_h5',
          name: 'messageAppearDetailH5',
          component: () => import('@/view_message_appear/messageAppearDetailH5.vue'),
        },
        {
          path: '/message_appear_history',
          name: 'messageAppearHistory',
          component: () => import('@/view_message_appear/messageAppearHistory.vue'),
        },
        {
          path: '/add_location_type',
          name: 'addLocationType',
          component: () => import('@/view_message_appear/poiComponent/locationType.vue'),
        },
        {
          path: '/add_location_detail',
          name: 'addLocationDetail',
          component: () => import('@/view_message_appear/poiComponent/locationDetail.vue'),
        },
        {
          path: '/staff_report',
          name: 'staffReport',
          component: () => import('@/view_message_appear/poiComponent/staffLocationDetail.vue'),
        },
        {
          path: '/report_success',
          name: 'reportSuccess',
          component: () => import('@/view_message_appear/submitSucess.vue'),
        },
      ],
    },
    {
      ...lotteryRouter
    },
    {
      ...onlineInviteRoutes,
    }
  ]
});
// const getUserInfo = () => {
//   return new Promise(resolve => {
//     if (hotEvent && !store.getters.userInfo) {
//       const userInfo = hotEvent.getInfo();
//       store.dispatch('setUserInfo', userInfo);
//       resolve();
//     } else {
//       if (window.location.host === 'localhost:8080') {
//         store.dispatch('setUserInfo', 'oA9LiwHNqZFMS5IztKOQfMmd1y5M/0');
//       }
//       resolve();
//     }
//   })
// }

const getUserInfo = () => {
  console.log(store.getters.userInfo, easyearn, store.getters.accessToken, store.getters.refreshToken, 'router');
  // 有改动
  if(window.location.pathname.includes('examination') || 
  window.location.pathname.includes('message')){
    if(easyearn && store.getters.accessToken){
      return
    }
  }else{
    if(easyearn && store.getters.userInfo){
      return
    }
  }
  // console.log(easyearn.getAccessToken(), easyearn.getRefreshToken(), 888);
  return new Promise(resolve => {

    var UA = navigator.userAgent.toLowerCase();
    if (UA.indexOf("Chrome") > 0 && window.location.pathname.includes('examination')) {
      var index = UA.split("Chrome/")[1].substring(0, 2);
      if (index <= 60) {
        // alert("您的安卓版本过低，暂不支持查看用户等级，请升级后使用！");
        alert("您的手机版本较低，正在为您跳转至网页进行考试");
        // window.easyearn.goBack();
        // return;
      }
    }
    if (easyearn && !store.getters.accessToken && Object.prototype.hasOwnProperty.call(easyearn, 'getAccessToken')) {
      const accessToken = easyearn.getAccessToken();
      const refreshToken = easyearn.getRefreshToken();
      store.dispatch('setAccessToken', accessToken);
      store.dispatch('setRefreshToken', refreshToken);
    }
    // 版本号 >= 32102007 不传openId  为false
    // isHaveOpenId  true 为 传
    if (easyearn && !store.getters.versioncode && Object.prototype.hasOwnProperty.call(easyearn, 'getVersionCode')) {
      const versioncode = easyearn.getVersionCode();
      const isHaveOpenId = Number(versioncode) >= Number(32102007)
      ? false : true;
      console.log(versioncode, 'versioncode');
      store.dispatch('setVersioncode', versioncode);
      store.dispatch('setHaveOpenId', isHaveOpenId);
    }
    if (easyearn && !store.getters.userInfo &&  Object.prototype.hasOwnProperty.call(easyearn, 'getOpenId')) {
      const userInfo = easyearn.getOpenId();
      store.dispatch('setUserInfo', userInfo);
      // resolve();
    } else if(easyearn && !store.getters.userInfo && ! Object.prototype.hasOwnProperty.call(easyearn, 'getOpenId')){
      const userInfo = easyearn.getInfo();
      store.dispatch('setUserInfo', userInfo);
      // resolve();
    }  else {
      if (
        window.location.href.includes('previewBtn')
        || window.location.href.includes('examination')
        || window.location.pathname.includes('onlineinvite')
        || window.location.pathname.includes('message')
        || window.location.pathname.includes('lottery')
        || window.location.pathname.includes('location')
        || window.location.pathname.includes('staff_rep')
        || window.location.pathname.includes('report_success')
      ) {
        // store.dispatch('setUserInfo', 'oA9LiwCfXRDKN1GDkwSIK7HFnmnc');
        // store.dispatch('setUserInfo', 'oA9LiwOVHRl63Ax_H19o7jQ0O8Xo');
        // store.dispatch('setUserInfo', 'oA9LiwKQobL62mcxErCTE7Eb4N7U');
        if (store.state.isH5) {
          store.dispatch('setHaveOpenId', false);
        }
        store.dispatch('setHaveOpenId', false);
        // store.dispatch('setHaveOpenId', true);
        store.dispatch('setVersioncode', 32102007);
        if(!store.state.isH5) {
          store.dispatch('setAccessToken', 'a0a4fe7e22914d1ea521a263a1a53da1');
          store.dispatch('setRefreshToken', '03485e99a1674fc986e32872ff86e2a7');
        }
        // store.dispatch('setUserInfo', 'oA9LiwJPoAah6MWl-zPOSLChE8c4');
        // store.dispatch('setUserInfo', 'oA9LiwFy66JcrTkKiQAZjAE4C6iE');
      }
      // resolve();
    }
    resolve();
  })
}

router.beforeEach(async () => {
  await getUserInfo();
});

export default router;
